import CodeQuoteStatusList from "./pages/ListPage.vue";
import CodeQuoteStatusDetail from "./pages/FormPage.vue";
import CodeQuoteStatusIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/code_quote_status",
    component: CodeQuoteStatusIndex,
    redirect: "/code_quote_status/list",
    name: "code_quote_status",
    children: [
      {
        path: "list",
        component: CodeQuoteStatusList,
        name: "code_quote_status.list",
      },
      {
        path: "create",
        component: CodeQuoteStatusDetail,
        name: "code_quote_status.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: CodeQuoteStatusDetail,
        name: "code_quote_status.edit",
        props: { create: false },
      },
    ],
  },
];
